module.exports = __webpack_public_path__ + "01_very_short_brown.681ef7dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_very_short_brown.png
// module id = OqFr
// module chunks = 0